export const STORIES_PATH = '/explore/stories';

export const storyDetailPath = (storyId: string): string =>
    `${STORIES_PATH}/${encodeURIComponent(storyId)}`;
